import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Homepage from './pages/Homepage/Homepage';
import MentionsLegales from './pages/MentionLegales/MentionLegales';
import './App.css';
import Agency from "./pages/Agency/Agency";
import Syndic from "./pages/Syndic/Syndic";
import RentalManagement from "./pages/RentalManagement/RentalManagement";
import Transaction from "./pages/Transaction/Transaction";
import Contact from "./pages/Contact/Contact";

const App: React.FC = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/agency" element={<Agency />} />
                <Route path="/syndic" element={<Syndic />} />
                <Route path="/rental_management" element={<RentalManagement />} />
                <Route path="/transaction" element={<Transaction />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
};

export default App;
